import { DashboardData, SiteStats, getSiteSamples, getStats } from "./dashboardData";
import { SiteCoordinates, SiteData, hasCoordinates } from "./site";
import { wellLevelsSitesReference } from "./wellLevelsData";

export interface MapSite extends SiteStats {
  coordinates: SiteCoordinates;
}

export function matSitesFromDashboard({ sites, samples }: DashboardData): MapSite[] {
  return sites.filter(hasCoordinates).map((site) => {
    const siteSamples = getSiteSamples(site.siteName, samples);

    return { ...site, ...getStats(siteSamples) };
  });
}

export function mapSitesFromWellLevelsData(siteData: SiteData[], siteStats: SiteStats[]): MapSite[] {
  const withCoordinates = siteData.filter(hasCoordinates);
  const mapSites: MapSite[] = [];
  siteStats.forEach((siteStat) => {
    const siteCoordinates = withCoordinates.find(
      (site) =>
        site.siteName === wellLevelsSitesReference[siteStat.siteName as keyof typeof wellLevelsSitesReference].name,
    );

    if (!siteCoordinates) return;
    mapSites.push({ ...siteStat, coordinates: siteCoordinates.coordinates });
  });

  return mapSites;
}
